module.exports = __webpack_public_path__ + "static/media/PM92.4414d7fe.png";